export const parseDateTimeForUrl = (date: Date) =>
  date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

export const getWeekEnd = function (startDate: Date): Date {
  let endDate = new Date(startDate);
  endDate.setDate(endDate.getDate() + (endDate.getDay() === 0 ? 0 : 7 - endDate.getDay()));
  if (endDate.getMonth() !== startDate.getMonth()) {
    endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
  }
  return endDate;
};

export const toLocalISOString = (date: Date | string) => {
  const dateTime = new Date(date);
  const offsetMs = dateTime.getTimezoneOffset() * 60000;
  const localTime = new Date(dateTime.getTime() + offsetMs);
  return localTime.toISOString();
};

export function toIsoWithDateOffset(date: Date, useOffset: boolean) {
  const pad = (n: number) => String(Math.floor(Math.abs(n))).padStart(2, '0');

  const offsetMinutes = -date.getTimezoneOffset();
  const tzSign = offsetMinutes >= 0 ? '+' : '-';
  const tzHours = pad(Math.floor(offsetMinutes / 60));
  const tzMinutes = pad(offsetMinutes % 60);

  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    'T' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds()) +
    '.' +
    String(date.getMilliseconds()).padStart(3, '0') +
    (useOffset ? tzSign + tzHours + ':' + tzMinutes : 'Z')
  );
}

export function getMonthRanges(date: Date) {
  const year = date.getFullYear();

  const fromDate = new Date(year, 0, 1, 0, 0, 0, 0);
  const toDate = new Date(year, 11, 31, 23, 59, 59, 999);

  const monthRanges: { startDate: Date; endDate: Date }[] = [];

  for (let month = 0; month < 12; month++) {
    const startDate = new Date(year, month, 1);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(year, month + 1, 0);
    endDate.setHours(23, 59, 59, 999);

    monthRanges.push({ startDate, endDate });
  }

  return { fromDate, toDate, monthRanges };
}
